import { bool, func, node, oneOf } from 'prop-types'
import { Component } from 'react'
import Modal from '../Modal/unmanaged'
import { kuiperClassNames } from '../utils'
import './styles.scss'

const newTheme = (oldTheme) => (oldTheme === 'light' ? 'dark' : 'light')

class Lightbox extends Component {
  static propTypes = {
    children: node,
    onClose: func,
    shouldConfirmExit: bool,
    theme: oneOf(['light', 'dark']),
    visible: bool,
  }

  static defaultProps = {
    onClose: () => {},
    theme: 'light',
  }

  constructor(props) {
    super(props)
    this.state = {
      theme: this.props.theme,
    }
  }

  toggleTheme = () => {
    this.setState((prevState) => ({ theme: newTheme(prevState.theme) }))
  }

  renderToggleButton = (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={kuiperClassNames('toggle-button')}
      onClick={() => this.toggleTheme()}
    />
  )

  render() {
    return (
      <Modal
        headerContents={this.renderToggleButton}
        customClassname="lightbox"
        onClose={this.props.onClose}
        shouldConfirmExit={this.props.shouldConfirmExit}
        visible={this.props.visible}
        theme={this.state.theme}
      >
        {this.props.children}
      </Modal>
    )
  }
}

export default Lightbox
